// @flow
import React from 'react';
import { Trans } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import { Heading } from '@rover/kibble/components';
import { DSTokenMap } from '@rover/kibble/styles';
import type { PetDetailForDisplay } from '@rover/react-lib/types';

import OverflowTextSection from '../OverFlowTextSection';

const { SPACE_8X } = DSTokenMap;

type Props = {
  petDetails: Array<PetDetailForDisplay>,
  slug: string,
  className?: String,
};

const DetailWrapper: StyledComponent<{}> = styled.div`
  margin-top: ${SPACE_8X};
`;

// we have to use own translated word 'Medication' because valueDisplayName='Select all medication'
const createMedicationComponent = (petDetails: Array<PetDetailForDisplay>) => {
  const slugDetails = petDetails.filter((info) => info.slug === 'medication');
  if (!slugDetails || slugDetails.length === 0) return null;

  const info = slugDetails.map((slug) => (
    <OverflowTextSection
      key={`${slug.value}${slug.displayName}`}
      text={`${slug.valueDisplayName} - ${slug.additionalInformation}`}
      type="small"
    />
  ));
  return (
    <>
      <Heading size="200" marginBottom="1x" textColor="primary">
        <Trans>Medication</Trans>
      </Heading>
      {info}
    </>
  );
};

const renderComponent = (petDetails: Array<PetDetailForDisplay>, slug: string) => {
  const slugDetails = petDetails.find((info) => slug === info.slug);
  if (!slugDetails) return null;

  return (
    <>
      <Heading size="200" marginBottom="1x" textColor="primary">
        {slugDetails.displayName}
      </Heading>
      <OverflowTextSection
        text={slugDetails.additionalInformation || slugDetails.valueDisplayName || ''}
        type="small"
      />
    </>
  );
};

const PetDetailFieldView = ({ petDetails, slug, className = '' }: Props) => {
  return (
    <DetailWrapper className={className}>
      {slug === 'medication'
        ? createMedicationComponent(petDetails)
        : renderComponent(petDetails, slug)}
    </DetailWrapper>
  );
};

export default PetDetailFieldView;



// WEBPACK FOOTER //
// ../react-lib/src/pages/pets/PetProfilePage/components/CareInfo/PetDetailFieldView.jsx